import { ReturnBaseUrl } from '@/network/request'
import { getAccountPreference, setAccountPreference } from '@/common/app-preference'
const read = (name, fallback) => getAccountPreference(ReturnBaseUrl(), sessionStorage.getItem('userId'), name, fallback)
const write = (name, value) => setAccountPreference(ReturnBaseUrl(), sessionStorage.getItem('userId'), name, value)
export const entryVisible = () => read('aiEntryVisibleV1', true) !== false
export const setEntryVisible = value => write('aiEntryVisibleV1', value === true)
export const voiceDirectSend = () => read('aiVoiceDirectSendV1', false) === true
export const setVoiceDirectSend = value => write('aiVoiceDirectSendV1', value === true)
export const hasConsent = version => !!version && read('aiConsentVersionV1', '') === version
export const saveConsent = version => { if (version) write('aiConsentVersionV1', version) }
// 仅接受应用内控制页来源；直接访问时回到控制首页。
export const returnPath = path => typeof path === 'string' && /^\/controlpage(?:\/|\?|$)/.test(path) ? path : '/controlpage/home'

let tabInitialized = false
// 新文档导航（含新标签页）不继承被复制的会话指针；刷新/前进后退仍可恢复。
export function initializeTabSession() {
  if (tabInitialized) return
  tabInitialized = true
  const navigation = typeof performance !== 'undefined' && performance.getEntriesByType && performance.getEntriesByType('navigation')[0]
  if (!navigation || navigation.type !== 'navigate') return
  try {
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const key = sessionStorage.key(i)
      if (key && key.startsWith('aiSession:v2:')) sessionStorage.removeItem(key)
    }
  } catch (_) { /* 存储受限不影响设备控制。 */ }
}
